import { App, type URLOpenListenerEvent } from '@capacitor/app'

import { supabase } from '@/lib/auth/client'

import { platform } from '../platform'

export function wireDeepLinks(navigate: (to: string) => void) {
  if (!platform.isNative()) return
  App.addListener('appUrlOpen', async (event: URLOpenListenerEvent) => {
    const url = new URL(event.url)
    if (
      url.pathname.endsWith('/auth/callback') ||
      event.url.startsWith('mysterra://auth/callback')
    ) {
      const code = url.searchParams.get('code')
      if (code) {
        const { error } = await supabase.auth.exchangeCodeForSession(code)
        if (!error) navigate('/today')
        return
      }
    }
    if (url.pathname.startsWith('/share/insight/')) {
      navigate(url.pathname + url.search)
    }
  })
}
